import { render, staticRenderFns } from "./createStudent.vue?vue&type=template&id=c7f1dec2&scoped=true&"
import script from "./createStudent.vue?vue&type=script&lang=js&"
export * from "./createStudent.vue?vue&type=script&lang=js&"
import style0 from "./createStudent.vue?vue&type=style&index=0&id=c7f1dec2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7f1dec2",
  null
  
)

export default component.exports